import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import classNames from 'classnames';
import React, { useRef, Fragment } from 'react';
import { insertBR } from './utils.esm.js';
import extractStringNodes from '../../utils/extract-string-nodes.esm.js';
import makeId from '../../utils/make-id.esm.js';
import Text from '../_primitives/text/text.esm.js';
import Expander from '../text-container/expander.esm.js';

var _excluded = ["id", "key", "className", "children", "as"];
var TextFormatter = function TextFormatter(props) {
  var id = props.id,
    key = props.key,
    className = props.className,
    children = props.children,
    _props$as = props.as,
    asProps = _props$as === void 0 ? 'p' : _props$as,
    rest = _objectWithoutProperties(props, _excluded);
  var identifierRef = useRef(id || makeId());
  var expander = React.Children.toArray(children).filter(function (i) {
    return i && i.type === Expander;
  });
  var contentList = extractStringNodes(React.Children.toArray(children).filter(function (i) {
    return typeof i === 'string';
  }));
  var _text = insertBR("".concat(contentList));
  var paragraphs = _text.split('<br>').filter(function (i) {
    return !!i;
  });
  return /*#__PURE__*/React.createElement(Text, _extends({
    key: key || "".concat(identifierRef.current),
    className: classNames('csg-tui-text-formatter', className)
  }, rest), paragraphs.map(function (v, i) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: "".concat(identifierRef.current, "-").concat(i)
    }, /*#__PURE__*/React.createElement(Text, {
      as: asProps
    }, "".concat(v).concat(i === paragraphs.length - 1 && expander.length > 0 ? ' ' : ''), i === paragraphs.length - 1 ? expander : ''), asProps === 'span' && /*#__PURE__*/React.createElement("br", null));
  }));
};

export default TextFormatter;
//# sourceMappingURL=text-formatter.esm.js.map
